// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-icon-button":"sapcnqr-icon-button-be1ea3","sapcnqr-icon-button--lg":"sapcnqr-icon-button--lg-bf7c91","sapcnqr-icon-button--wide":"sapcnqr-icon-button--wide-526181"};